export default __webpack_public_path__ + "static/media/3.a77f5496.png";